<template>
    <div class="container" :class="{'androidMode': isAndroidMode()}">
        <div class="mode-container">
            <div class="title">
                <h1>{{ getString('pedido_para') }}</h1>
            </div>
            <div class="content">
                <div class="mode" v-if="modeEntrega.find(e => e === 'comer')" @click="chooseModoEntrega('comer')">
                    <img :src="imgComerAqui">
                    <span v-text="getString('comer_aqui')"></span>
                </div>
                <div class="mode" v-if="modeEntrega.find(e => e === 'levar')" @click="chooseModoEntrega('levar')">
                    <img :src="imgToGo">
                    <span v-text="getString('viagem')"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Util from '@/assets/libs/util'
import LocaleController from '@/assets/controllers/LocaleController'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'ModeEntregaGom',
    data () {
        return {
            modeEntrega: [],
            imgToGo: Util.getConfigImage('toGo') || require('../../static/icons/viagem.jpg'),
            imgComerAqui: Util.getConfigImage('comerAqui') || require('../../static/icons/comer.jpg')
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        chooseModoEntrega: function (value) {
            Util.setLocalVar('modoentrega', value)
            value === 'levar' ? ClarityController.event('pedido_para_levar') : ClarityController.event('pedido_consumo_local')
            this.$emit('hideModoEntrega')
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        getImage: function () {
            return Util.getConfigImage('espera')
        }
    },
    mounted () {
        let config = Util.getLocalVar('taaconfig')
        this.modeEntrega = config['modeEntrega']
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");
    .position {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .container {
        .position;
        // background: rgba(0, 0, 0, 0.3);
        z-index: 100;
        .mode-container {
            .position;
            margin: auto 20px;
            height: max-content;
            max-height: 30vh;
            display: grid;
            grid-template-rows: 20% 80%;
            justify-content: center;
            align-items: center;
            background: white;
            border-radius: 15px;
            padding: 50px 0;
            h1  {
                position: relative;
                z-index: 1;
                // display: block;
                text-align: center;
                // transform: translate(-50%, -50%);
                font-size: 3em;
                padding-bottom: 50px;
            }
            .content {
                .mode{
                    padding: 5px;
                    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
                    display: inline-block;
                    margin: 0 50px -40px 50px;
                }
                img {
                    width: 280px;
                    height: 280px;
                    margin: auto;
                    display: block;
                }
                span{
                    padding-top: 5px;
                    font-size: 2.5rem;
                    text-align: center;
                    display: block;
                }
            }
        }
    }
    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .container .mode-container {
            margin: auto 10px;
            padding: 50px 0;
            h1 {
                font-size: 2.5rem;
            }
            .content {
                display: flex;
                img {
                    width: 230px;
                    height: 230px;
                }
                span{
                    font-size: 2.3rem;
                }
            }
        }
    }
    @media (max-width: 698px) { // Gertec SK210
        .container .mode-container {
            margin: auto 5px;
            padding: 5px 0 5px 0;
            .title {
                h1 {
                    font-size: 28px;
                    background: unset;
                    padding-bottom: 20px;
                }
            }
            .content {
                display: flex;
                justify-content: center;
                .mode {
                    margin: 20px;
                }
                img {
                    width: 170px;
                    height: 170px;
                }
                span{
                    font-size: 22px;
                }
            }
        }
    }
    @media (orientation: landscape) {
        .container {
            .mode-container {
                margin: auto;
                max-width: fit-content;
                max-height: max-content;
                grid-template-rows: 10% 90%;
                h1 {
                    font-weight: normal;
                    font-size: 2.1em;
                    color: @primary-dark;
                }
                .content {
                    display: flex;
                    .mode {
                        color: @primary-dark;
                        border-top: 1px solid rgba(116, 116, 116, 0.226);
                        border-left: 1px solid rgba(116, 116, 116, 0.226);
                    }
                    img {
                        width: 230px;
                        height: 230px;
                    }
                    span{
                        font-size: 2.1rem;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ModeEntregaGom.vue